var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://docs.google.com/spreadsheets/d/e/2PACX-1vQHtdV1SDBCFYLS0gMXxGHKDsoabcv-x4ogF_IbWrO-p2-5Bx_WW_J0F5NYLCTj7CZJPSbNEu8BwXh1/pubhtml?gid=299828536&single=true&widget=true&headers=false"}})
}
var staticRenderFns = []

export { render, staticRenderFns }